import { AssistantGrounding } from "@/services/modules/assistant";
import { ToolCallIndicator } from "./ToolCallIndicator";

export function GroundingMeta({ grounding }: { grounding?: AssistantGrounding }) {
  if (!grounding?.grounded && (!grounding?.tool_calls || grounding.tool_calls.length === 0)) {
    return null;
  }

  return (
    <div className="mt-2 space-y-1.5">
      {grounding.tool_calls && grounding.tool_calls.length > 0 && (
        <ToolCallIndicator tools={grounding.tool_calls} />
      )}
      <div className="flex flex-wrap gap-1.5">
        <span className="rounded-md border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
          {grounding.source === "knowledge" ? "Base PI" : grounding.source === "tools" ? "Tools" : "Contexto"}
        </span>
        {grounding.branch_id ? (
          <span className="rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 text-[10px] text-slate-600">
            Tenant filtrado
          </span>
        ) : null}
        {grounding.citations && grounding.citations.length > 0 ? (
          <span className="rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 text-[10px] text-slate-600">
            {grounding.citations.length} citação(ões)
          </span>
        ) : null}
      </div>
    </div>
  );
}
